<dx-select-box
  label="Status"
  [value]="value"
  [class]="classList"
  (valueChange)="valueChange.emit($event)"
  [items]="items"
  [readOnly]="readOnly"
  [stylingMode]="stylingMode"
  [labelMode]="labelMode"
  width="100%"
  fieldTemplate="field"
>
  <div *dxTemplate="let data of 'field'" class="status-editor-field">
    <contact-status class="status-indicator" [showText]="false" [value]="data">
    </contact-status>
    <dx-text-box
      class="status-{{ data | lowercase }}"
      [hoverStateEnabled]="false"
      [inputAttr]="{ class: 'status-input status-editor-input' }"
      [readOnly]="true"
      [value]="data"
    >
    </dx-text-box>
  </div>
  <div *dxTemplate="let data of 'item'">
    <contact-status [value]="data"> </contact-status>
  </div>
</dx-select-box>
